import React, { useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/icon/hun-com-logo-desktop-white-img.svg";
import GroupSelectModal from "../Feature/GroupSelectModal/GroupSelectModal";
import PageOne from "./Pages/PageOne";
import PageTwo from "./Pages/PageTwo";

const LoginApp: React.FC<RouteComponentProps> = (props) => {
  const [pageIdx, setPageIdx] = useState<number>(0);

  const goNextPage = () => setPageIdx((prev) => prev + 1);
  const goPrevPage = () => setPageIdx((prev) => prev - 1);

  const uiContent = (): React.ReactElement | null => {
    switch (pageIdx) {
      case 0:
        return <PageOne {...props} goNextPage={goNextPage} />;
      case 1:
        return (
          <PageTwo {...props} goPrevPage={goPrevPage} goNextPage={goNextPage} />
        );
      case 2:
        return <GroupSelectModal onClose={() => setPageIdx(0)} />;
      default:
        return null;
    }
  };

  return (
    <main className="login">
      <header className="login__header">
        <Logo />
      </header>
      {uiContent()}
    </main>
  );
};

export default LoginApp;
